import { sendWebsocketMessage } from '../../../../../../App';

export function unwrapTradePlan(tradePlanId, cancelOpenOrders = false) {
  sendWebsocketMessage({
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'unwrapTradePlan',
    value: {
      cancelOpenOrders,
    },
  });
}
